export enum IndicatorColours {
    INDICATOR_COLOUR_LOW="#ff4d4d",
    INDICATOR_COLOUR_CAUTION_LOW="#f2d579",
    INDICATOR_COLOUR_OK="#49cb49",
    INDICATOR_COLOUR_CAUTION_HIGH="#f2d579",
    INDICATOR_COLOUR_HIGH="#ff4d4d",
};